import { Box, Skeleton } from '@mui/material';

/** Number of placeholder rows when the caller does not pass a count. */
const SKELETON_ROW_COUNT = 3;

/** Line widths cycle so rows do not look like a uniform table. */
const LINE_WIDTHS = ['100%', '78%', '62%'] as const;

/**
 * Placeholder rows for the transcript list: muted timestamp chip and body lines.
 * Renders inside Panel; the shell and header live on the parent.
 */
export function TranscriptionSkeleton({ rowCount = SKELETON_ROW_COUNT }: { rowCount?: number }) {
  return (
    <Box>
      {Array.from({ length: rowCount }).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            gap: 1.5,
            py: 1,
            px: 1,
          }}
        >
          <Skeleton variant="rounded" width={48} height={24} sx={{ flexShrink: 0 }} />
          <Box sx={{ flex: 1, minWidth: 0 }}>
            {index % 2 === 0 ? (
              <Skeleton
                variant="text"
                width="28%"
                height={16}
                sx={{ display: 'block', mb: 0.25 }}
              />
            ) : null}
            <Skeleton
              variant="text"
              width={LINE_WIDTHS[index % LINE_WIDTHS.length]}
              height={20}
              sx={{ display: 'block' }}
            />
            {index % 3 === 0 ? (
              <Skeleton variant="text" width="90%" height={20} sx={{ display: 'block' }} />
            ) : null}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
